import BaseRadioGroup from '@material-ui/core/RadioGroup'

const RadioGroup = BaseRadioGroup

export default RadioGroup
